import { TableCell, TableHead, Table, TableBody, TableRow, TableFooter, Button, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { OrderQuery } from '../../../../services/query';
import TimeHelper from '../../../../utils/time';
import { useTranslation } from 'react-i18next';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import { USHSD } from './userSaleOrderStatusHistoryDrawer.classes';

function UserSaleOrderStatusHistoryDrawer({ orderId, onClose }: any) {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);

    const { t } = useTranslation();

    const handleClose = () => {
        if (onClose) onClose();
    };

    useEffect(() => {
        OrderQuery.GetUserSaleOrderStatusHistory({ orderId }).then((res) => {
            if (res) {
                setData(res);
            }
            setLoading(false);
        });
    }, []);

    if (loading) {
        return (
            <div
                className={USHSD.loadingWrap}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                }}
            >
                <CircularProgress className={USHSD.loadingInner} size={100} />
            </div>
        );
    }

    return (
        <div className={USHSD.root} style={{ padding: '2rem' }}>
            {data ? (
                <>
                    <div className={USHSD.header} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className={USHSD.title} style={{ color: '#5b99f3', marginBottom: '2rem' }}>
                            {t('orderDetail.orderStatusHistory')}
                        </h2>
                        <Button className={USHSD.closeButton}>
                            <CloseIcon
                                className={USHSD.closeIcon}
                                style={{ height: 'auto', width: '25px' }}
                                onClick={handleClose}
                            />
                        </Button>
                    </div>
                    <Table className={USHSD.table}>
                        <TableHead>
                            <TableRow className={USHSD.tableHeadRow}>
                                <TableCell className={USHSD.headCellDate}>{t('orderDetail.date')}</TableCell>
                                <TableCell>{t('orderDetail.user')}</TableCell>
                                <TableCell>{t('orderDetail.userType')}</TableCell>
                                <TableCell>{t('general.status')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row: any, index: number) => (
                                <TableRow key={index} className={USHSD.bodyRow}>
                                    <TableCell className={USHSD.bodyCellDate}>
                                        {TimeHelper.formatDateHour(row.date)}
                                    </TableCell>
                                    <TableCell className={USHSD.bodyCellUser}>{row.userName}</TableCell>
                                    <TableCell className={USHSD.bodyCellUserType}>
                                        {row.isOperator ? <p style={{ color: 'blue' }}>Backoffice</p> : <p>Web</p>}
                                    </TableCell>
                                    <TableCell className={USHSD.bodyCellStatus}>
                                        {row.orderStatusDescription} {row.rmaCode > 0 && `(${row.rmaCode})`}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow className={USHSD.footerRow}>
                                <TableCell colSpan={3} />
                                <TableCell align="right">
                                    {t('orderDetail.totalRecordsCount')} {data.length}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </>
            ) : (
                <div
                    className={USHSD.emptyWrap}
                    style={{
                        color: '#666463',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '2rem',
                    }}
                >
                    <HighlightOffIcon className={USHSD.emptyIcon} style={{ width: '40px', height: 'auto' }} />
                    <h2 className={USHSD.emptyTitle} style={{ marginLeft: '2rem' }}>
                        {t('orderDetail.orderStatusHistoryCannotFound')}
                    </h2>
                </div>
            )}
        </div>
    );
}

export default UserSaleOrderStatusHistoryDrawer;
